import DetailsLeads from "@/components/Lead/Leads/DetailsLeads";
import GetAllLeads from "@/components/Lead/Leads/GetAllLeads";
import GetAllLeadSource from "@/components/Lead/LeadSource/GetAllLeadSource";
import GetAllLeadStatus from "@/components/Lead/LeadStatus/GetAllLeadStatus";
import GetAllCampaignCode from "@/components/Lead/CampaignCode/GetAllCampaignCode";
import Loader from "@/components/Loader/Loader";
import PermissionChecker from "@/components/PrivacyComponent/PermissionChecker";
import { Suspense, lazy } from "react";
import { Route } from "react-router-dom";

const LeadRoutes = [
  <Route
    path="lead"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={["readAll-lead", "readSingle-lead"]}>
          <GetAllLeads />
        </PermissionChecker>
      </Suspense>
    }
    key="lead"
  />,
  <Route
    path="lead/:id"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={"readSingle-lead"}>
          <DetailsLeads />
        </PermissionChecker>
      </Suspense>
    }
    key="lead-single"
  />,
  <Route
    path="lead-source"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={"readAll-leadSource"}>
          <GetAllLeadSource />
        </PermissionChecker>
      </Suspense>
    }
    key="lead-source"
  />,
  <Route
    path="lead-status"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={"readAll-leadStatus"}>
          <GetAllLeadStatus />
        </PermissionChecker>
      </Suspense>
    }
    key="lead-status"
  />,
  <Route
    path="campaign-code"
    element={
      <Suspense fallback={<Loader />}>
        <PermissionChecker permission={"readAll-campaignCode"}>
          <GetAllCampaignCode />
        </PermissionChecker>
      </Suspense>
    }
    key="campaign-code"
  />,
];

export default LeadRoutes;
